import { addBloodExplosion } from "@/presentation/renderers/animations/bloodExplosion.js";
import { createBaseLineActor } from "./lineActor.js";
import { flashScreen } from "@/presentation/renderers/animations/flashScreen.js";
import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";

export function createDuckPrefab(k, card, position, index) {
    const teamColor = card.team.color;
    
    const duck = createBaseLineActor(k, {
        sprite: "sheep",
        spriteOptions: {anim: "idle", flipX: true},
        position,
        index,
        isDuck: true,
        z: 8,
        tags: [ACTOR_TAGS.LINE_DUCK],
        extraComponents: [
            k.color(teamColor.r, teamColor.g, teamColor.b)
        ]
    });

    duck.slide = async (targetX, duration) => {
        duck.play("run");
        const sound = k.play("grass_step", { volume: 1.3, loop: true });
        await k.tween(
            duck.pos,
            k.vec2(targetX, duck.pos.y),
            duration,
            (v) => duck.pos = v,
            k.easings.linear
        );
        duck.play("idle");
        sound.stop();
    };

    duck.jumpTo = async (targetPos, duration = 0.6) => {
        if (duck.isAnimating) return;
        duck.isAnimating = true;
        duck.play("run");

        const fromPos = duck.pos.clone();
        const arcHeight = 120;
        const midY = Math.min(fromPos.y, targetPos.y) - arcHeight;

        k.play("jump", { volume: 0.5 });
        k.tween(fromPos.x, targetPos.x, duration, (v) => {
            duck.pos = k.vec2(v, duck.pos.y);
        }, k.easings.linear);

        await k.tween(fromPos.y, midY, duration / 2, (v) => {
            duck.pos = k.vec2(duck.pos.x, v);
        }, k.easings.easeOutQuad);

        await k.tween(midY, targetPos.y, duration / 2, (v) => {
            duck.pos = k.vec2(duck.pos.x, v);
        }, k.easings.easeInQuad);

        duck.play("idle");
        duck.isAnimating = false;
    };

    duck.hit = async () => {
        k.shake(30);
        flashScreen(k);
        k.play("sheepSceam", { volume: 0.5, speed: 1.8 });
        const explosion = addBloodExplosion(k, { pos: duck.pos });
        duck.destroy();
        await explosion;
    };

    duck.poke = async () => {
        k.play("sheep", { volume: 0.5 });
        await duck.jump();
    };

    duck.jump = async() => {
        if (duck.isAnimating) return;
        duck.isAnimating = true;

        const startY = duck.pos.y;
        await k.tween(0, Math.PI, 0.25, (t) => {
            duck.pos = k.vec2(duck.pos.x, startY - (Math.sin(t) * 30));
        }, k.easings.linear).onEnd(() => {
            duck.pos = k.vec2(duck.pos.x, startY);
            duck.isAnimating = false;
        });
    }

    return duck;
}
